import { render, staticRenderFns } from "./GapListWidgetRequirements.vue?vue&type=template&id=72eeb6d5&scoped=true&"
import script from "./GapListWidgetRequirements.vue?vue&type=script&lang=ts&"
export * from "./GapListWidgetRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eeb6d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
